module.exports = __webpack_public_path__ + "static/media/30.618b0703.png";